// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__2JX-4","summary":"CartItem_summary__uPEqj","price":"CartItem_price__3Va_M","amount":"CartItem_amount__13eyv","actions":"CartItem_actions__2a0w2"};